import React, { Component } from "react";
import styled, { ThemeConsumer } from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

//const multiple = nota.global.multiple;

const StyledTimeline = styled.div`
  width: 100%;
  margin: 10px 0;
  height: 18px;
  .timelineWrapper {
    height: 0.5px;
    background-color: ${nota.color.neutral.NeuTwo};
    .dotsWrapper {
      width: 100%;
      margin-top: -10px;

      .timelineOption {
        cursor: pointer;
        height: auto;

        .timelineDot {
          width: 10px;
          height: 10px;
          background-color: ${nota.color.neutral.NeuTwo};
          border-radius: 100%;
        }

        &:hover {
          .timelineDot {
            background-color: ${nota.color.neutral.NeuTree};
          }
          p {
            opacity: 0.7;
          }
        }
      }
      .selected {
        .timelineDot {
          background-color: ${nota.color.main.default};
        }
        p {
          color: ${nota.color.main.default};
        }
      }
    }
  }
`;

class Timeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
      selectedDurations: this.props.selectedDurations ?? [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevState.selectedDurations) !== JSON.stringify(this.state.selectedDurations) && this.props.onChangeSelection) {
      this.props.onChangeSelection({ selectedDurations: this.state.selectedDurations ?? [] });
    }

    if (JSON.stringify(prevProps.selectedDurations) !== JSON.stringify(this.props.selectedDurations) || this.props.forceSelection) {
      this.setState({ selectedDurations: this.props.selectedDurations ?? [] });
    }

    if (prevProps.options !== this.props.options) {
      this.setState({ options: this.props.options });
    }
  }

  timelineClick = (v) => {
    if (this.state.selectedDurations.includes(v)) {
      this.setState({
        selectedDurations: this.state.selectedDurations.filter((item) => {
          return JSON.stringify(item) !== JSON.stringify(v);
        }),
      });
    } else {
      this.setState({ selectedDurations: [...this.state.selectedDurations, ...[v]] });
    }
  };

  render() {
    if (!this.state.options) return null;

    return (
      <StyledTimeline>
        <NanoFlex className="timelineWrapper">
          <NanoFlex className="dotsWrapper" justifyContent="space-around" alignItems="flex-start">
            {this.state.options.map((v) => {
              return (
                <NanoFlex
                  key={v}
                  className={`timelineOption ${this.state.selectedDurations.includes(v) ? "selected" : ""}`}
                  flexDirection="column"
                  onClick={() => {
                    this.timelineClick(v);
                  }}>
                  <NanoFlex className="timelineDot"></NanoFlex>
                  <Type.p>{v}</Type.p>
                </NanoFlex>
              );
            })}
          </NanoFlex>
        </NanoFlex>
      </StyledTimeline>
    );
  }
}

// Set default props
Timeline.defaultProps = {};

export default Timeline;

// --- // Documentation // --- //
/*
import Timeline from './../Nano/Timeline.js';

<Timeline />
*/
